// extracted by mini-css-extract-plugin
module.exports = {"terms-list-container":"TermsListContainer_terms-list-container___Jxqp","searched":"TermsListContainer_searched__7lU7R"};